function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".announcement_svg__c{opacity:.2}.announcement_svg__d{fill:#0c0f13}.announcement_svg__h{fill:#454b54}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 39,
  fill: "#ffaa26"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.734 59.53h-17.41a11.589 11.589 0 01-11.607-11.553A11.634 11.634 0 0132.324 36.37h17.41",
  fill: "#f7f7fb"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "announcement_svg__c"
}, React.createElement("path", {
  className: "announcement_svg__d",
  d: "M32.324 59.53h17.41v-6.335h-17.41a11.626 11.626 0 01-11.181-8.413 12.505 12.505 0 00-.426 3.195A11.589 11.589 0 0032.324 59.53z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.287 68.209c0-6.39-5.217-8.679-11.606-8.679V36.37c6.389 0 11.606-2.29 11.606-8.678h2.875v40.517z",
  fill: "#f37865"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "announcement_svg__c"
}, React.createElement("path", {
  className: "announcement_svg__d",
  d: "M49.734 53.195v6.335c6.389 0 11.607 2.29 11.607 8.679h-.054v-6.336h.054c-.054-6.389-5.218-8.678-11.607-8.678z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M61.287 66.771v-2.449a11.788 11.788 0 00-2.608-1.917c1.65 1.97 2.608 1.598 2.608 4.366z",
  fill: "#ebebea"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.324 59.53a2.613 2.613 0 012.608 2.61v11.18a3.577 3.577 0 003.355 3.62 3.478 3.478 0 003.567-3.46V62.14a2.613 2.613 0 012.609-2.61",
  fill: "#e4caa6"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "announcement_svg__c"
}, React.createElement("path", {
  className: "announcement_svg__d",
  d: "M44.463 59.53h-12.14a2.613 2.613 0 012.61 2.61v2.289h6.974v-2.29a2.535 2.535 0 012.556-2.609z"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "announcement_svg__h",
  d: "M79.283 46.38h-5.217a1.597 1.597 0 100 3.194h5.217a1.597 1.597 0 100-3.194zM74.066 43.77a1.681 1.681 0 001.011-.372l3.46-2.875a1.588 1.588 0 10-2.022-2.45l-3.461 2.876a1.548 1.548 0 00-.213 2.236 1.592 1.592 0 001.225.586zM75.077 52.556a1.588 1.588 0 00-2.023 2.449l3.46 2.875a1.405 1.405 0 001.012.373 1.596 1.596 0 001.012-2.822zM65.813 40.752v-13.06a3.027 3.027 0 00-6.036-.338 1.703 1.703 0 00-.034.337c0 4.686-3.354 7.082-10.01 7.082h-17.41a13.177 13.177 0 100 26.355 1.01 1.01 0 011.012 1.011V73.32a5.203 5.203 0 004.898 5.218h.16a5.09 5.09 0 005.058-5.058v-6.725a7.378 7.378 0 005.628-5.627h.602c6.655 0 10.01 2.396 10.01 7.08a1.653 1.653 0 00.105.576 3.026 3.026 0 002.982 2.513 3.08 3.08 0 003.035-3.088V55.197a7.396 7.396 0 000-14.445zM40.203 73.48a1.766 1.766 0 01-.532 1.33 2.101 2.101 0 01-1.331.533h-.053a1.951 1.951 0 01-1.81-2.023V62.14a5.9 5.9 0 00-.107-1.012h3.94a6.526 6.526 0 00-.107 1.011zm3.248-10.056v-1.285a1.01 1.01 0 011.012-1.011h1.284a4.16 4.16 0 01-2.296 2.296zm6.23-5.49a1.672 1.672 0 00-.401.052h-1.222a1.537 1.537 0 00-.802 0h-2.392a1.672 1.672 0 00-.401-.053h-12.14a1.698 1.698 0 00-.343.036 9.982 9.982 0 01-9.527-8.395h3.162a1.602 1.602 0 001.597-1.597 1.569 1.569 0 00-1.597-1.597h-3.162a9.943 9.943 0 01.427-1.704h4.173a1.597 1.597 0 000-3.195H24.71a9.977 9.977 0 017.614-3.514h15.813v8.146a1.597 1.597 0 103.194 0v-8.196c6.243-.384 10.194-3.072 11.287-7.605v35.416c-1.106-4.998-5.702-7.795-12.937-7.795zm16.132-6.07V44.09a4.2 4.2 0 010 7.773z"
});

function SvgAnnouncement(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default __webpack_public_path__ + "announcement.c0a41.svg";
export { SvgAnnouncement as ReactComponent };